customerForm.$inject = ['$rootScope', 'AppService', '$timeout', '$uibModal', 'AuthService']

export default function customerForm($rootScope, AppService, $timeout, $uibModal, AuthService) {
  var directive = {
    restrict: 'E',
    replace: true,
    scope: {
      customer: '=',
      activeTab: '='
    },
    link: function(scope, elem, attrs) {
      scope.$parent[attrs.property] = this
      this.isPristine = () => scope.customerForm.$pristine

      scope.filePath = $rootScope.filePath
      AppService.getMediaPlacements().then(res => scope.mediaPlacements = res.data)
      scope.startDate = false
      scope.endDate = false
      scope.startDateOptions = {
        startingDay: 1
      }
      scope.endDateOptions = {
        minDate: new Date(),
        startingDay: 1
      }

      scope.uploadMedias = function(files, placement, invalidFiles) {
        files.forEach((file, index) => {
          scope.uploadedFile = true
          $rootScope.$on('uploadProgress', (event, data) => scope.uploadProgress = data)

          AppService.uploadMedia(file).then(res => {
            var file = res.data

            scope.uploadProgress = 100.0
            $timeout(function() {
              scope.hideAlert('uploadedFile')
            }, 5000)

            if (!scope.customer.contact.medias) scope.customer.contact.medias = new Array()

            var media, originalMedia
            new Promise((resolve, reject) => {
              if (file.type.includes('video')) {
                AppService.getMediaById(file.attrs.mediaId).then(res => {
                  originalMedia = file
                  media = res.data
                  resolve()
                })
              } else {
                media = file
                resolve()
              }
            }).then(() => {
              var existingContactToMediasSamePlacement = scope.customer.contact.medias.filter(media => media.mediaPlacement.placement.toLowerCase() == placement)
              var mediaPlacement = scope.mediaPlacements.find(mediaPlacement => mediaPlacement.placement.toLowerCase() == placement)
              var newContactToMediaSamePlacement = {
                order: existingContactToMediasSamePlacement.length + 1,
                mediaId: file.id,
                mediaPlacementId: mediaPlacement.id,
                media: media,
                mediaPlacement: mediaPlacement
              }
              if (originalMedia) newContactToMediaSamePlacement.originalMedia = originalMedia
              scope.customer.contact.medias.push(newContactToMediaSamePlacement)
              if (existingContactToMediasSamePlacement.length === 1 && existingContactToMediasSamePlacement[0].mediaPlacement.isReplace) {
                var index = scope.customer.contact.medias.findIndex(media => media === existingContactToMediasSamePlacement[0], 1)
                scope.customer.contact.medias.splice(index, 1)
                newContactToMediaSamePlacement.order = newContactToMediaSamePlacement.order - 1
              }
            })
          })
        })
        invalidFiles.forEach((file, index) => {
          scope.invalidFile = true
          scope.file = file
          $timeout(function() {
            scope.hideAlert('invalidFile')
          }, 5000)
        })
      }
      scope.addCommunication = function() {
        if (!scope.customer.contact.communications) scope.customer.contact.communications = new Array()
        scope.customer.contact.communications.push({
          order: scope.customer.contact.communications.length + 1,
          isPrimary: scope.customer.contact.communications.length === 0 ? true : undefined
        })
      }
      scope.deleteCommunication = function(index) {
        scope.customer.contact.communications.splice(index, 1)
      }
      scope.toggleStartDate = function() {
        scope.startDate = !scope.startDate
      }
      scope.toggleEndDate = function() {
        scope.endDate = !scope.endDate
      }
      scope.isSysUser = function() {
        if (scope.customer.isSysUser) {
          $uibModal.open({
            controller: 'ModalSysUserController',
            controllerAs: 'modalSysUser',
            template: require('../auth/sys-user-modal-new.html'),
            resolve: {
              contact: function() {
                return scope.customer.contact
              }
            }
          }).result.then(sysUser => {
            scope.customer.sysUserId = sysUser.id
            scope.customer.sysUser = sysUser
          }, () => {
            scope.customer.isSysUser = false
          })
        } else {
          scope.customer.isSysUser = true
          scope.confirmSysUserDelete = true
        }
      }
      scope.doSysUserDelete = function() {
        scope.hideAlert('confirmSysUserDelete')
        AuthService.deleteSysUser(scope.customer.sysUser).then(() => {
          scope.customer.isSysUser = false
          scope.customer.sysUser = null
          scope.customer.sysUserId = null
        })
      }
      scope.removeMedia = function(media) {
        var index = scope.customer.contact.medias.findIndex(media2 => media2.id === media.id)
        scope.customer.contact.medias.splice(index, 1)
      }
      scope.hideAlert = function(alert) {
        scope[alert] = false
      }
    },
    template: require('./_form-customer.html')
  }

  return directive
}